import { Spinner } from '@change/ds-core-ui';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { DecisionMakerProfilePagePrefetchedDataProps } from 'src/app/pages/decisionMakerProfile/pageContext';
import {
	DecisionMakerProfilePageContextProvider,
	prefetchPageContext,
} from 'src/app/pages/decisionMakerProfile/pageContext';

import { Layout } from '../layout';

import { DecisionMakerProfileErrorHandler } from './ErrorHandler';

export const DecisionMakerProfile = withPrefetchedData(
	function DecisionMakerProfile({ prefetchedData }: DecisionMakerProfilePagePrefetchedDataProps) {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		return (
			<DecisionMakerProfilePageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				errorHandler={DecisionMakerProfileErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</DecisionMakerProfilePageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.slug!, context),
	},
);
